/** Cross-component “open this support ticket” signal (toast / push / SW). */

export const SUPPORT_OPEN_EVENT = 'yp-support-open';

export type SupportOpenDetail = {
  ticketId: number;
  fresh?: boolean;
};

export function requestOpenSupportTicket(ticketId: number, fresh = true): void {
  if (!Number.isFinite(ticketId) || ticketId <= 0) return;
  window.dispatchEvent(
    new CustomEvent<SupportOpenDetail>(SUPPORT_OPEN_EVENT, {
      detail: { ticketId, fresh },
    }),
  );
}

export function parseSupportOpenMessage(data: unknown): SupportOpenDetail | null {
  if (!data || typeof data !== 'object') return null;
  const row = data as { type?: string; ticketId?: unknown; ticket_id?: unknown };
  if (row.type !== 'support-open') return null;
  const ticketId = Number(row.ticketId ?? row.ticket_id ?? 0);
  if (!Number.isFinite(ticketId) || ticketId <= 0) return null;
  return { ticketId, fresh: true };
}
